import React, { useEffect, useState } from 'react';
import HiringSection from './HiringSection';
import { useHiringAssessmentDashboard } from 'src/hooks/hiringAssessment.hooks';
interface AssessmentItem {
	id: number;
	process: string;
	count: number;
	positionData?: {
		assessmentPending: number;
		interviewing: number;
	};
	unseenApplicationCount?: number;
}

const AssessmentHiringSection = () => {
	const {
		data: hiringAssessmentDashboardData,
		refetch,
		isLoading: hiringAssessmentDashboardDataLoading,
	} = useHiringAssessmentDashboard();
	const [assessmentArray, setAssessmentArray] = useState<AssessmentItem[]>([
		{ id: 1, process: 'Assessments', count: 0 },
		{
			id: 2,
			process: 'Candidates Invited',
			count: 0,
			positionData: { assessmentPending: 0, interviewing: 0 },
		},
		{ id: 3, process: 'Candidates Assessed', count: 0, unseenApplicationCount: 0 },
		{ id: 4, process: 'Hired', count: 0 },
		{ id: 5, process: 'Rejected', count: 0 },
	]);
	useEffect(() => {
		const intervalId = setInterval(() => {
			refetch();
		}, 3000);

		return () => clearInterval(intervalId);
	}, [refetch]);

	useEffect(() => {
		if (hiringAssessmentDashboardData?.result) {
			setAssessmentArray([
				{ ...assessmentArray[0], count: hiringAssessmentDashboardData?.result?.hiringAssessmentCount },
				{ ...assessmentArray[1], count: hiringAssessmentDashboardData?.result?.candidatesInvitedCount },
				{
					...assessmentArray[2],
					count: hiringAssessmentDashboardData?.result?.candidatesAssessedCount,
					unseenApplicationCount: hiringAssessmentDashboardData?.result?.unseenApplicationsCount,
				},
				{ ...assessmentArray[3], count: hiringAssessmentDashboardData?.result?.candidatesHiredCount },
				{ ...assessmentArray[4], count: hiringAssessmentDashboardData?.result?.candidatesRejectedCount },
			]);
		}
	}, [hiringAssessmentDashboardData]);

	return (
		<HiringSection
			heading="Benchmark Candidates"
			subheading="Assess & benchmark your existing candidates for FREE"
			positions={assessmentArray}
			linkUrl="/recruiter-dashboard/hiring-assessment-list"
			linkText="Manage →"
			logoSrc="/assets/recruiterDashboard/assessmenthiring.svg"
		/>
	);
};

export default AssessmentHiringSection;
